<template>
    <div class="star-group d-flex flex-row">
        <span class="icon-svg" :style="{width: size+'px'}">
            <svg class="star-group" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2272 441.999" style="opacity: 0">
                <mask :id="'star-group__mask-'+id">
                    <g fill="#fff" :stroke="fill" stroke-width="10px">
                        <path d="M411.325 165.244L277.584 152.84 224.458 29.477c-3.72-8.638-15.967-8.638-19.686 0L151.646 152.84 17.905 165.244c-9.365.868-13.15 12.516-6.084 18.723l100.908 88.646-29.531 131.03c-2.068 9.174 7.84 16.372 15.927 11.571l115.49-68.576 115.49 68.576c8.087 4.802 17.994-2.397 15.927-11.572L316.5 272.613l100.909-88.646c7.065-6.207 3.28-17.855-6.084-18.723z" />
                        <path d="M869.325 165.244L735.584 152.84 682.458 29.477c-3.72-8.638-15.967-8.638-19.686 0L609.646 152.84l-133.741 12.405c-9.365.868-13.15 12.516-6.084 18.723l100.908 88.646-29.531 131.03c-2.068 9.174 7.84 16.372 15.927 11.571l115.49-68.576 115.49 68.576c8.087 4.802 17.994-2.397 15.927-11.572L774.5 272.613l100.909-88.646c7.065-6.207 3.28-17.855-6.084-18.723z" />
                        <path d="M1790.71 165.244l-133.741-12.404-53.126-123.363c-3.72-8.638-15.967-8.638-19.686 0l-53.126 123.362-133.741 12.405c-9.365.868-13.149 12.516-6.084 18.723l100.908 88.646-29.531 131.03c-2.068 9.174 7.841 16.372 15.927 11.571L1594 346.638l115.49 68.576c8.087 4.802 17.994-2.397 15.927-11.572l-29.532-131.029 100.909-88.646c7.065-6.207 3.28-17.855-6.084-18.723z" />
                        <path d="M1329.71 165.244l-133.741-12.404-53.126-123.363c-3.72-8.638-15.967-8.638-19.686 0l-53.126 123.362-133.741 12.405c-9.365.868-13.149 12.516-6.084 18.723l100.908 88.646-29.531 131.03c-2.068 9.174 7.841 16.372 15.927 11.571L1133 346.638l115.49 68.576c8.087 4.802 17.994-2.397 15.927-11.572l-29.532-131.029 100.909-88.646c7.065-6.207 3.28-17.855-6.084-18.723z" />
                        <path d="M2247.71 165.244l-133.741-12.404-53.126-123.363c-3.72-8.638-15.967-8.638-19.686 0l-53.126 123.362-133.741 12.405c-9.365.868-13.149 12.516-6.084 18.723l100.908 88.646-29.531 131.03c-2.068 9.174 7.841 16.372 15.927 11.571L2051 346.638l115.49 68.576c8.087 4.802 17.994-2.397 15.927-11.572l-29.532-131.029 100.909-88.646c7.065-6.207 3.28-17.855-6.084-18.723z" />
                    </g>
                </mask>
                <g fill="none" :stroke="fill" stroke-width="10px" class="star-group__placeholder">
                    <path d="M411.325 165.244L277.584 152.84 224.458 29.477c-3.72-8.638-15.967-8.638-19.686 0L151.646 152.84 17.905 165.244c-9.365.868-13.15 12.516-6.084 18.723l100.908 88.646-29.531 131.03c-2.068 9.174 7.84 16.372 15.927 11.571l115.49-68.576 115.49 68.576c8.087 4.802 17.994-2.397 15.927-11.572L316.5 272.613l100.909-88.646c7.065-6.207 3.28-17.855-6.084-18.723z" />
                    <path d="M869.325 165.244L735.584 152.84 682.458 29.477c-3.72-8.638-15.967-8.638-19.686 0L609.646 152.84l-133.741 12.405c-9.365.868-13.15 12.516-6.084 18.723l100.908 88.646-29.531 131.03c-2.068 9.174 7.84 16.372 15.927 11.571l115.49-68.576 115.49 68.576c8.087 4.802 17.994-2.397 15.927-11.572L774.5 272.613l100.909-88.646c7.065-6.207 3.28-17.855-6.084-18.723z" />
                    <path d="M1329.71 165.244l-133.741-12.404-53.126-123.363c-3.72-8.638-15.967-8.638-19.686 0l-53.126 123.362-133.741 12.405c-9.365.868-13.149 12.516-6.084 18.723l100.908 88.646-29.531 131.03c-2.068 9.174 7.841 16.372 15.927 11.571L1133 346.638l115.49 68.576c8.087 4.802 17.994-2.397 15.927-11.572l-29.532-131.029 100.909-88.646c7.065-6.207 3.28-17.855-6.084-18.723z" />
                    <path d="M1790.71 165.244l-133.741-12.404-53.126-123.363c-3.72-8.638-15.967-8.638-19.686 0l-53.126 123.362-133.741 12.405c-9.365.868-13.149 12.516-6.084 18.723l100.908 88.646-29.531 131.03c-2.068 9.174 7.841 16.372 15.927 11.571L1594 346.638l115.49 68.576c8.087 4.802 17.994-2.397 15.927-11.572l-29.532-131.029 100.909-88.646c7.065-6.207 3.28-17.855-6.084-18.723z" />
                    <path d="M2247.71 165.244l-133.741-12.404-53.126-123.363c-3.72-8.638-15.967-8.638-19.686 0l-53.126 123.362-133.741 12.405c-9.365.868-13.149 12.516-6.084 18.723l100.908 88.646-29.531 131.03c-2.068 9.174 7.841 16.372 15.927 11.571L2051 346.638l115.49 68.576c8.087 4.802 17.994-2.397 15.927-11.572l-29.532-131.029 100.909-88.646c7.065-6.207 3.28-17.855-6.084-18.723z" />
                </g>
                <rect class="star-group__progress" :fill="fill" x="0" y="0" :width="value + '%'" height="100%" :mask="'url(#star-group__mask-' + id + ')'" />
            </svg>
        </span>
    </div>
</template>
<style scope>
.star-group>[class*='icon-']:not(:last-child) {
    margin-right: 5px;
}
</style>
<script>
import { gsap } from "gsap"
import { DrawSVGPlugin } from "@/plugins/gsap/DrawSVGPlugin.min.js"
gsap.registerPlugin(DrawSVGPlugin)

export default {
    props: ['value', 'id', 'color', 'size', 'fill'],
    mounted() {
        this.$nextTick(() => {
            // Star animation init
            this.starAnimation()
        })
    },

    methods: {
        /*
         * Star animation helpers
         */
        starAnimation() {
            let starGroup = this.$el.querySelector('.star-group'),
                starsPlaceholders = this.$el.querySelectorAll('.star-group__placeholder > path'),
                progressBar = this.$el.querySelector('.star-group__progress'),
                tl = gsap.timeline()

            gsap.set(starGroup, { autoAlpha: 1 })

            tl.from(starsPlaceholders, {
                    duration: 0.5,
                    drawSVG: "50% 50%",
                    stagger: 0.2
                })
                .from(starsPlaceholders, {
                    duration: 0.5,
                    stagger: 0.2,
                    scale: 0,
                    transformOrigin: "center",
                    ease: "back.out(1.7)"
                }, 0)
                .from(progressBar, {
                    duration: 2,
                    width: 0,
                    ease: "power4.out"
                })
        }
    }
}
</script>